import styles from './ComparisonSection.module.css'

type Row = {
  feature: string
  other: string
  us: string
  usHot?: boolean
}

const ROWS: Row[] = [
  {
    feature: 'Regras de pontuação',
    other: 'Fixas, decididas pela plataforma',
    us: 'Você define cada evento e cada peso',
    usHot: true,
  },
  {
    feature: 'Formatos de liga',
    other: 'Pontos corridos, só',
    us: 'Pontos · H2H semanal · Sobrevivente',
    usHot: true,
  },
  {
    feature: 'Liga eliminatória semanal',
    other: '—',
    us: 'Sobrevivente · exclusivo Fantyx',
    usHot: true,
  },
  {
    feature: 'Esports e multi-esporte',
    other: '—',
    us: 'CS2 em set/2026, basquete em out/2026',
  },
  {
    feature: 'Prize pool de liga privada',
    other: 'Padrão fixo',
    us: 'Você define o valor de entrada',
  },
]

export function ComparisonSection() {
  return (
    <section className={styles.section}>
      <div className={styles.head}>
        <div>
          <div className={styles.num}>VS · CONCORRÊNCIA</div>
          <h2 className={styles.heading}>
            Mesmo esporte.{' '}
            <span className={styles.glow}>Outro jogo.</span>
          </h2>
        </div>
        <div className={styles.headRight}>
          O que dá pra fazer aqui que nas outras plataformas você não faz —
          sem rodeios.
        </div>
      </div>

      <div className={styles.table} role="table" aria-label="Comparação Fantyx vs outras plataformas">
        <div className={`${styles.row} ${styles.rowHead}`} role="row">
          <span className={styles.colFeature} role="columnheader" />
          <span className={`${styles.colOther} ${styles.colHead}`} role="columnheader">
            As outras plataformas
          </span>
          <span className={`${styles.colUs} ${styles.colHead}`} role="columnheader">
            Fantyx.Pro
          </span>
        </div>

        {ROWS.map((row) => (
          <div key={row.feature} className={styles.row} role="row">
            <span className={styles.colFeature} role="cell">{row.feature}</span>
            <span className={styles.colOther} role="cell">
              {row.other === '—'
                ? <span className={styles.dash}>—</span>
                : row.other}
            </span>
            <span
              className={`${styles.colUs} ${row.usHot ? styles.colUsHot : ''}`}
              role="cell"
            >
              <span className={styles.check}>✓</span>
              {row.us}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
